import React, { FC } from 'react';
import { MultiSelectOption } from './row';

interface OptionsSelectorProps {
  selectedOption: number | string | boolean;
  handleOptionChange: (option: Number | String | MultiSelectOption | boolean) => void;
  options: MultiSelectOption[];
  title: string;
}

const OptionsSelector: FC<OptionsSelectorProps> = ({ selectedOption, handleOptionChange, options, title }) => {
  return (
    <>
      <h1 className="text-base font-bold text-gray-500 mt-4">
        {title}
      </h1>
      <div className="mt-4 inline-flex bg-gray-200 rounded-lg">
        {options.map((option, index) => (
          <div
            key={option.id ?? index} // Use the id from the object if present, otherwise use the index
            onClick={() => handleOptionChange(option.data)}  // Use data for logic
            className={`
            py-2
            px-4  

            flex justify-center items-center // Center text
            text-center cursor-pointer 
            ${selectedOption === option.data ? 'bg-sky-500 text-white' : 'text-gray-400'}
            hover:${selectedOption != option.data ? 'bg-sky-200' : ''}
            font-bold
            text-sm
            transition-all duration-300 ease-in-out
            ${index === 0 ? 'rounded-l-lg' : ''}
            ${index === options.length - 1 ? 'rounded-r-lg' : ''}
            `}
          >
            {option.display}  {/* Use display for rendering */}
          </div>
        ))}
      </div>
    </>
  );
};

export default OptionsSelector;

